import React from 'react';

export default function MarketInfo() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h1 style={{ marginBottom: '50px' }} className="text-4xl md:text-5xl font-bold text-white">
  Market Info
</h1>

        <div className="space-y-30">
          {/* Forex */}
          <div>
            <h2 className="text-purple-300 mb-2" style={{ fontSize: '40px' }}>
  1.Forex
</h2>
            <p style={{ fontSize: '20px',marginBottom: '40px' }} className="text-gray-300 leading-relaxed">
  Forex is the global market where currencies are bought and sold. It’s the largest financial market in the world,
  with over <span className="text-white font-semibold">$7 trillion</span> traded daily.
</p>
          </div>

          {/* Comex */}
          <div>
            <h2 className="text-purple-300 mb-2" style={{ fontSize: '40px' }}>
  2.Comex
</h2>
            <p style={{ fontSize: '20px',marginBottom: '40px'}} className="text-gray-300 leading-relaxed">
  Comex, short for Commodities Exchange, refers to a regulated marketplace for trading standardized contracts
  of raw materials like <span className="text-white font-semibold">gold and silver</span>.
</p>

          </div>

          {/* Crypto */}
          <div>
            <h2 className="text-purple-300 mb-2" style={{ fontSize: '40px' }}>
  3.Crypto
</h2>
            <p style={{ fontSize: '20px',marginBottom: '40px'}} className="text-gray-300 leading-relaxed">
  The crypto market is a digital marketplace to trade cryptocurrencies like <span className="text-white font-semibold">Bitcoin</span> and <span className="text-white font-semibold">Ethereum</span>.
  It runs 24/7 on decentralized networks.
</p>

          </div>
        </div>
      </div>
    </section>
  );
}
